import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserResolverService } from '../services/user-resolver.service';

const STORE_SELECTOR_ROUTE = '/store-selector';

export function normalizeStoreReturnUrl(returnUrl: string | null | undefined): string {
    if (!returnUrl?.startsWith('/') || returnUrl.startsWith('//') || returnUrl.startsWith(STORE_SELECTOR_ROUTE)) {
        return '/';
    }

    return returnUrl;
}

export const storeContextGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const userResolverService = inject(UserResolverService);
    const redirectToStoreSelector = () => router.createUrlTree([STORE_SELECTOR_ROUTE], {
        queryParams: { returnUrl: normalizeStoreReturnUrl(state.url) }
    });

    return userResolverService.userInfo$.pipe(
        take(1),
        timeout(environment.httpRequestTimeoutMs),
        map(userInfo => {
            if (userInfo.LocID) {
                return true;
            }

            return redirectToStoreSelector();
        }),
        catchError(() => of(redirectToStoreSelector()))
    );
};
